import {
   AfterViewInit,
   Component,
   EventEmitter,
   Input,
   NgModule,
   OnInit,
   Output,
   TemplateRef,
   ViewChild
} from '@angular/core';
import {DxDataGridComponent} from "devextreme-angular";
import {Prodotto} from "../../../models/Prodotto";
import {DxService} from "../../../services/dx.service";
import {ServerService} from "../../../services/server.service";
import {DialogService} from "../dialog/dialog.service";
import {GuiService} from "../../../services/gui.service";
import {DataService} from "../../../services/data.service";
import {ProdottoVariante, ProdottoVarianteFactory} from "../../../models/ProdottoVariante";
import {PopupSchedaColor} from "../../dialogs/popup-generic/popup-generic.component";


@Component({
   selector: 'app-tabella-varianti',
   templateUrl: './tabella-varianti.component.html',
   styleUrls: ['./tabella-varianti.component.scss']
})
export class TabellaVariantiComponent implements OnInit, AfterViewInit {
   @ViewChild('gridVarianti') gridVarianti!:DxDataGridComponent;
   @ViewChild("templateVariant") templateVariant!: TemplateRef<any>

   @Input() isVendor = false;
   @Input() vendorSlug;
   @Input() isShop = false;
   @Input() shopId;

   @Output() clickNewProduct: EventEmitter<any> = new EventEmitter<any>()
   public productVariant:ProdottoVariante = new ProdottoVariante({});

   Prodotto = Prodotto
   headerFilterStagioneData: any;
   popupSync:boolean = false
   itemsCount:number = 0
   public colorId;

   prodottoId;
   pVarianteId;

   popupTermsButtons:any = [];
   headerFilterSync: any;

   constructor(private dxSrv: DxService,
               private serverSrv: ServerService,
               private dialogSrv: DialogService,
               private guiSrv: GuiService,
               private dataSrv: DataService,
               private productVariantFctr: ProdottoVarianteFactory,
   ) {
      this.headerFilterStagioneData = Prodotto.STAGIONI
      this.headerFilterSync = ProdottoVariante.HeaderFilterStatoData
   }

   ngOnInit(): void {
   }

   ngAfterViewInit(): void {
      this.initVariantiTable()
   }

   public refreshGridLayout() {
      this.dxSrv.fixGridLayout(this.gridVarianti);
   }

   initVariantiTable(){
      let url = this.isVendor ? `/api/esercizi/${this.vendorSlug}/productvariants?is_general=1` : `/api/productvariants`
      console.log(url)
      this.dxSrv.initGrid(this.gridVarianti, {showAdd: true, showRefresh:true, btnAddText:this.isShop ? 'Abilita Sync' : 'Nuovo Prodotto', iconAddBtn:this.isShop ? 'fal fa-sync' : 'fal fa-plus',
         onClickNew:()=>{
            if (this.isShop){
               this.popupSync = true
               this.itemsCount = this.gridVarianti.instance.getDataSource().items().length
            }else {
               this.clickNewProduct.emit()
            }
         }
      }, url).then(() => {
         // this.calculateStatistics()
      })

      this.gridVarianti.onRowPrepared.subscribe((rowInfo:any)=>{
         if(rowInfo.rowType == 'data'){
            if(rowInfo.data.qta_instance_gt_0 > 100){
               console.log(rowInfo)
               $(rowInfo.rowElement).addClass("bg-red-300");
            }
         }
      })
   }

   clickOpenVariantPage(cellInfo) {

      console.log(cellInfo)
      this.prodottoId = cellInfo.data.prodotto.id;
      this.pVarianteId = cellInfo.data.id;
      this.openVarianteModal()
      // const url = this.router.serializeUrl(
      //    this.router.createUrlTree(!this.isShop ? [cellInfo.data.prodotto.id] : ['../../prodotti-varianti/'+cellInfo.data.prodotto.id],
      //       {queryParams: {'tab': 1, 'variante': cellInfo.data.id}, relativeTo:this.route})
      // );
      // window.open(url, '_blank');
   }

   clickSelectVariant(data: any){
      console.log(data)

   }

   fetchVariant() {
      this.productVariantFctr.getPVariant(this.prodottoId, this.pVarianteId, this.vendorSlug).then(res => {
         console.log(res)
         this.productVariant = new ProdottoVariante(res.data)
         this.colorId = this.productVariant?.data?.colore!.toString()
      })
   }

   openVarianteModal(){
      this.fetchVariant()
      this.dialogSrv.openCustomModal({
         mode: "rb",
         content: this.templateVariant,
         title: 'Dettagli prodotto',
         subtitle: 'Scheda Varianti',
         scheda_color: PopupSchedaColor.GIALLO,
         buttons: [],
         no_animation: false
      })

   }

   clickSyncShop(mode, confirm=false) {
      let dxFilter = this.gridVarianti.instance.getCombinedFilter()
      let url = `/api/esercizi/${this.dataSrv.esercizioUser.esercizio.data.id}/shops/${this.shopId}/enable_prod_sync`
      let data = {
         dxFilter:dxFilter,
         shop:this.shopId,
         mode:mode,
         confirm: confirm
      }

      if (!confirm){
         this.serverSrv.post(url, data).then(async (res)=>{
            await this.guiSrv.hideLoading()
            let lbl = !mode ? "DISATTIVATI" : "ATTIVATI"
            this.dialogSrv.showConfirm({title:"Abilita sincronizzazione prodotti", msg:`<span class="font-bold">${res}</span>
                                           prodotti verranno ${lbl} per la sincronizzazione. Vuoi continuare?`}).then(()=>{
               this.clickSyncShop(mode, true)
            })
         }).catch(err=>{
            this.dialogSrv.showToastError({err:err, title:"Impossibile completare l'operazione"})
         }).finally(()=>{
            this.popupSync = false
            this.guiSrv.hideLoading()
         })
      }else {
         this.serverSrv.post(url, data).then(async (res)=>{
            this.gridVarianti.instance.refresh()
            console.log(res)
         }).catch(err=>{
            this.dialogSrv.showToastError({err:err, title:"Errore!"})
         }).finally(()=>{
            this.guiSrv.hideLoading()
         })
      }



   }

}
